import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme, Button, ButtonGroup } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import { withStyles } from '@material-ui/core/styles';
import * as CommonConstants from "utilities/CommonConstants";
import * as DbValueConstants from "utilities/DbValueConstants";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            marginRight: theme.spacing(5),
            marginLeft: theme.spacing(5),
            marginBottom: theme.spacing(1),
            textAlign: `center`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // 次へ
    handleNext: VoidFunction;
}

/**
 * 予約種別選択コンポーネント
 * 予約種別を選択するコンポーネント
 * @param props
 */
export const SelectBookingType: React.FC<Props> = (props) => {
    const { booking, handleNext } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    useEffect(() => {}, []);

    const BookingTypeButtion = withStyles({
        root: {
            color: '#ffffff',
            '&:hover': {
                opacity: 0.8,
            },
            fontSize: 'small',
        },
    })(Button)

    const handleClick = (value: number) => {
        booking.bookingTypeId = value;
        handleNext();
      };

    return (
        <div className={classes.form}>
            <ButtonGroup
                size="large"
                orientation="vertical"
                aria-label="vertical outlined button group"
            >
                <BookingTypeButtion
                    disableTouchRipple
                    style={{
                        backgroundColor: CommonConstants.BOOKING_TYPE_COLOR_TAKEOUT,
                        outlineColor: CommonConstants.BOOKING_TYPE_COLOR_TAKEOUT,
                    }}
                    onClick={() => {handleClick(DbValueConstants.BOOKING_TYPE_ID_TAKEOUT);}}
                >
                    {CommonConstants.BOOKING_TYPE_NAME_TAKEOUT} <br/>ジエチルエーテル(特級)、ジエチルエーテル(脱水)、ペンタン、汲出し１及び２にある種類の溶媒
                </BookingTypeButtion>
                <BookingTypeButtion
                    disableTouchRipple
                    style={{
                        backgroundColor: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT1,
                        outlineColor: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT1,
                    }}
                    onClick={() => {handleClick(DbValueConstants.BOOKING_TYPE_ID_POMPOUT1);}}
                >
                    {CommonConstants.BOOKING_TYPE_NAME_POMPOUT1} <br/>｛アセトン、メタノール、酢酸エチル(EP)、酢酸エチル(特級)、エタノール99.5(特級)、エタノール(IPA変性)、アセトニトリル、トルエン｝
                </BookingTypeButtion>
                <BookingTypeButtion
                    disableTouchRipple
                    style={{
                        backgroundColor: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT2,
                        outlineColor: CommonConstants.BOOKING_TYPE_COLOR_POMPOUT2,
                    }}
                    onClick={() => {handleClick(DbValueConstants.BOOKING_TYPE_ID_POMPOUT2);}}
                >
                    {CommonConstants.BOOKING_TYPE_NAME_POMPOUT2} <br/>｛ヘキサン(鹿一級)、ヘキサン(HPLC)、テトラヒドロフラン、2-プロパノール｝
                </BookingTypeButtion>
            </ButtonGroup>
        </div>
    );
};
